import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useHistory } from 'react-router'

import IFindAll from 'modules/veiculos/domain/dtos/IFindAll'
import Veiculo from 'modules/veiculos/domain/entities/Veiculo'
import VeiculoPaginate from 'modules/veiculos/domain/entities/VeiculoPaginate'
import DeleteVeiculoImpl from 'modules/veiculos/domain/usecases/DeleteVeiculo'
import VeiculoRoutes from 'modules/veiculos/utils/VeiculoRoutes'
import Buscar from 'shared/components/Buscar'
import ContainerPage from 'shared/components/ContainerPageNew'
import Excluir from 'shared/components/Excluir'
import IconVeiculo from 'shared/components/Icons/IconVeiculo'
import Modal from 'shared/components/Modal'
import SnackBar from 'shared/components/SnackBar'
import Tab from 'shared/components/Tab'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'

import IActiveOrInactiveImpl from '../../domain/usecases/ActiveOrInactive'
import { IGetImagemVeiculo } from '../../domain/usecases/GetImagemVeiculo'
import { IListVeiculosImpl } from '../../domain/usecases/ListVeiculosImpl'
import TablePagination, { ITableHeaderData } from './components/TablePagination'
import Detalhes from './Detalhes'
import { Container, Content, Header, ItemContent } from './styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'

const tableHeadCavalo: ITableHeaderData[] = [
  {
    title: 'Placa cavalo',
  },
  {
    title: 'CNPJ',
  },
  {
    title: 'Status',
  },
  {
    title: 'Observação',
  },
  {
    title: 'Ações',
  },
]

const tableHeadCarreta: ITableHeaderData[] = [
  {
    title: 'Placa carreta',
  },
  { title: 'CNPJ' },
  {
    title: 'Status',
  },
  {
    title: 'Observação',
  },
  {
    title: 'Ações',
  },
]

type TProps = {
  findVeiculos: IListVeiculosImpl
  activeOrInactive: IActiveOrInactiveImpl
  deleteVeiculo: DeleteVeiculoImpl
  getImagemVeiculo: IGetImagemVeiculo
}

const initialPaginate: VeiculoPaginate = {
  current_page: 1,
  data: [],
  from: 1,
  per_page: 5,
  to: 1,
  total: 1,
  next_page: 1,
  prev_page: 1,
}

const per_page = 5

const List: FunctionComponent<TProps> = ({
  findVeiculos,
  activeOrInactive,
  deleteVeiculo,
  getImagemVeiculo,
}) => {
  const history = useHistory()

  const [activeMenu, setActiveMenu] = useState('cavalos')
  const [errorMessage, setErrorMessage] = useState('')
  const [currentPageCavalo, setCurrentPageCavalo] = useState(1)
  const [currentPageCarreta, setCurrentPageCarreta] = useState(1)
  const [loading, setLoading] = useState(false)
  const [cavalos, setCavalos] = useState<Veiculo[]>([])
  const [carretas, setCarretas] = useState<Veiculo[]>([])
  const [carretaPaginate, setCarretaPaginate] =
    useState<VeiculoPaginate>(initialPaginate)
  const [cavaloPaginate, setCavaloPaginate] =
    useState<VeiculoPaginate>(initialPaginate)
  const [placaCarreta, setPlacaCarreta] = useState('')
  const [placaCavalo, setPlacaCavalo] = useState('')

  const [openAlert, setOpenAlert] = useState(false)
  const [type, setType] = useState<'CAVALO' | 'CARRETA'>('CAVALO')
  const inputPlacaCaminhaoRef = useRef(null)

  const [openModalDetalhes, setOpenModalDetalhes] = useState(false)
  const [veiculoSelecionado, setVeiculoSelecionado] = useState<Veiculo>()
  const [situacaoVeiculoSelecionado, setSituacaoVeiculoSelecionado] =
    useState(false)

  const [openModalDeletar, setOpenModalDeletar] = useState(false)
  const [idSelecionado, setIdSelecionado] = useState(null)
  const [deletado, setDeletado] = useState(false)
  const [openModalImage, setOpenModalImage] = useState(false)
  const [urlImagemModal, setUrlImagemModal] = useState('')
  const [protocoloImagemModal, setProtocoloImagemModal] = useState('')
  const { frotistaId } = useFrotista()

  const fetchData = useCallback(
    async (params: IFindAll) => {
      try {
        params.list_status = [
          'VALID',
          'MANUAL_APPROVAL',
          'INVALID',
          'MANUAL_REPROVAL',
        ]
        params.frotista_id = frotistaId
        const response = await findVeiculos.execute(params)
        if (type === 'CAVALO') {
          setCavaloPaginate(response)
          setCavalos(response.data)
        } else if (type === 'CARRETA') {
          setCarretaPaginate(response)
          setCarretas(response.data)
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro ao buscar veículos')
        }
        setOpenAlert(true)
      }
      setLoading(false)
    },
    [findVeiculos, type, frotistaId],
  )

  useEffect(() => {
    setOpenAlert(false)
    setErrorMessage('')
    setLoading(true)

    const params = {
      page: type === 'CAVALO' ? currentPageCavalo : currentPageCarreta,
      per_page,
      tipo: type,
    } as IFindAll
    if (type === 'CAVALO' && placaCavalo) {
      params.placa = placaCavalo
    } else if (type === 'CARRETA' && placaCarreta) {
      params.placa = placaCarreta
    }

    fetchData(params)
  }, [
    type,
    currentPageCarreta,
    currentPageCavalo,
    findVeiculos,
    placaCarreta,
    placaCavalo,
    fetchData,
    frotistaId,
  ])

  const handleSubmit = useCallback(async (values, type) => {
    try {
      setType(type)
      if (type === 'CARRETA') {
        setCurrentPageCarreta(1)
        setPlacaCarreta(values.valueInput)
      } else if (type === 'CAVALO') {
        setCurrentPageCavalo(1)
        setPlacaCavalo(values.valueInput)
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Erro ao buscar veículos')
      }
      setOpenAlert(true)
    }
    setLoading(false)
  }, [])

  const handleDelete = useCallback(async (veiculo: Veiculo) => {
    setOpenModalDeletar(true)
    setIdSelecionado(veiculo.id)
  }, [])

  const handleDetail = useCallback(async (veiculo: Veiculo) => {
    setOpenModalDetalhes(true)
    setVeiculoSelecionado(veiculo)
    setSituacaoVeiculoSelecionado(veiculo.ativo)
  }, [])

  const handleImageModal = useCallback(
    async (id: number, protocolo: string) => {
      try {
        const response = await getImagemVeiculo.execute(id)
        setUrlImagemModal(response)
        setProtocoloImagemModal(protocolo)
        setOpenModalImage(true)
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro ao tentar buscar a image anexada para OCR')
        }
        setOpenAlert(true)
      }
    },
    [getImagemVeiculo],
  )

  const onCloseModal = () => {
    setOpenModalDetalhes(false)
    setVeiculoSelecionado(null)
    setOpenModalDeletar(false)
    setDeletado(false)

    const params = {
      page: type === 'CAVALO' ? currentPageCavalo : currentPageCarreta,
      per_page,
      tipo: type,
    } as IFindAll
    if (type === 'CAVALO' && placaCavalo) {
      params.placa = placaCavalo
    } else if (type === 'CARRETA' && placaCarreta) {
      params.placa = placaCarreta
    }
    fetchData(params)
  }

  const onDeleteVeiculo = async (id: number) => {
    setLoading(true)
    try {
      await deleteVeiculo.execute(id)
      setDeletado(true)
      setLoading(false)
    } catch (e: unknown) {
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao tentar deletar o veículo')
      }
      setOpenAlert(true)
      setLoading(false)
      onCloseModal()
    }
  }

  return (
    <ContainerPage
      breadCrumb="Veículos / Lista de veículos"
      showFooterScaffold={true}
      onClickNextButton={() =>
        history.push(VeiculoRoutes.CREATE, { origem: VeiculoRoutes.LIST })
      }
      titleNextButton="Novo veículo"
      iconButtonNext={IconVeiculo}
      colorNextButton={colors.green}
      onClickBackButton={null}
      title="Lista de veículo (s)"
      titleHeader="Novo veículo"
      loading={loading}
    >
      <Modal
        size={'large'}
        showCloseButton={true}
        openModal={openModalImage}
        onCloseModal={() => {
          setOpenModalImage(false)
          setUrlImagemModal('')
          setProtocoloImagemModal('')
        }}
      >
        <Text size={14}>Protocolo Idwall</Text>
        <Text color={colors.grayDark} size={14} weight={'700'}>
          {protocoloImagemModal}
        </Text>
        <img
          src={`data:image/png;base64,${urlImagemModal}`}
          style={{ marginTop: 10, maxHeight: 500, maxWidth: 800 }}
          alt="Imagem do protocolo"
        />
      </Modal>
      <Container>
        <Content>
          <Tab>
            <Tab.Item
              onClick={() => {
                setActiveMenu('cavalos')
                setType('CAVALO')
              }}
              active={activeMenu === 'cavalos'}
            >
              <span>Cavalos</span>
            </Tab.Item>
            <Tab.Item
              onClick={() => {
                setActiveMenu('carretas')
                setType('CARRETA')
              }}
              active={activeMenu === 'carretas'}
            >
              <span>Carretas</span>
            </Tab.Item>
          </Tab>
          {activeMenu === 'cavalos' && (
            <ItemContent>
              <Header>
                <Buscar
                  handleSubmit={values => handleSubmit(values, 'CAVALO')}
                  inputBuscarRef={inputPlacaCaminhaoRef}
                  label="Buscar Cavalo"
                  loading={loading}
                  placeholder="Digite a placa para buscar"
                />
              </Header>
              <TablePagination
                list={cavalos}
                perPage={per_page}
                currentPage={currentPageCavalo}
                setCurrentPage={setCurrentPageCavalo}
                tableHeadItems={tableHeadCavalo}
                total={cavaloPaginate?.total ?? 0}
                type="CAVALO"
                handleDelete={handleDelete}
                handleDetail={handleDetail}
                handleImageModal={handleImageModal}
              />
            </ItemContent>
          )}
          {activeMenu === 'carretas' && (
            <ItemContent>
              <Header>
                <Buscar
                  handleSubmit={values => handleSubmit(values, 'CARRETA')}
                  inputBuscarRef={inputPlacaCaminhaoRef}
                  label="Buscar Carreta"
                  loading={loading}
                  placeholder="Digite a placa para buscar"
                />
              </Header>
              <TablePagination
                list={carretas}
                perPage={per_page}
                currentPage={currentPageCarreta}
                setCurrentPage={setCurrentPageCarreta}
                tableHeadItems={tableHeadCarreta}
                total={carretaPaginate?.total ?? 0}
                type="CARRETA"
                handleDelete={handleDelete}
                handleDetail={handleDetail}
                handleImageModal={handleImageModal}
              />
            </ItemContent>
          )}
        </Content>
        <Detalhes
          veiculo={veiculoSelecionado}
          openModal={openModalDetalhes}
          checked={situacaoVeiculoSelecionado}
          onCloseModal={onCloseModal}
          activeOrInactive={activeOrInactive}
        />
        <Excluir
          openModalDeletar={openModalDeletar}
          onCloseModal={onCloseModal}
          title={'Excluir veículo'}
          subTitle={'Tem certeza que deseja excluir este veículo da sua lista?'}
          deletado={deletado}
          titleDeletado={'Veículo excluído!'}
          idSelecionado={idSelecionado}
          onDelete={onDeleteVeiculo}
        />
        <SnackBar
          open={openAlert}
          setOpen={setOpenAlert}
          severity="error"
          message={errorMessage}
        />
      </Container>
    </ContainerPage>
  )
}

export default List
